<template>
  <v-card-row actions v-if="value">
    <v-btn
      :loading="feedback.loading"
      @click.native.stop="cancel()"
      class="ml-3" flat>
      {{ $t('feedbackactions.cancel') }}
    </v-btn>
    <v-btn
      @click.native.stop="save()"
      :loading="feedback.loading"
      class="ml-3" primary light>
      {{ $t('feedbackactions.save') }}
    </v-btn>
  </v-card-row>
  <v-card-row actions v-else>
    <v-btn
      v-if="canEdit"
      :loading="feedback.loading"
      @click.native.stop="edit()"
      class="ml-3" flat>
      <span v-if="$can('edit', 'feedbacks')">{{ $t('feedbackactions.update') }}</span>
      <span v-else>{{ $t('feedbackactions.comment') }}</span>
    </v-btn>
    <v-btn
      v-if="canReject"
      @click.native.stop="reject({ id: feedback.id })"
      :loading="feedback.loading"
      class="ml-3" error light>
      {{ $t('feedbackactions.reject') }}
    </v-btn>
    <v-btn
      v-if="canAccept"
      @click.native.stop="accept({ id: feedback.id })"
      :loading="feedback.loading"
      class="ml-3" success light>
      {{ $t('feedbackactions.accept') }}
    </v-btn>
  </v-card-row>
</template>

<script>
  import { mapActions } from 'vuex'
  import Feedback from '@/api/feedback'
  export default {
    props: {
      value: {
        type: Boolean
      },
      feedback: {
        type: Object,
        required: true
      }
    },
    computed: {
      canEdit () {
        if (!this.feedback.accepted_at) { return true }
        return this.$can('editPublished', 'feedbacks')
      },
      canAccept () { return this.$can('edit', 'feedbacks') && Feedback.canAccept(this.feedback) },
      canReject () { return this.$can('edit', 'feedbacks') && Feedback.canReject(this.feedback) }
    },
    methods: {
      ...mapActions({
        accept: 'skiliko/feedbacks/accept',
        reject: 'skiliko/feedbacks/reject',
        saveFeedback: 'skiliko/feedbacks/save'
      }),
      save () {
        this.saveFeedback({ id: this.feedback.id, data: this.feedback.modifications })
          .then(_ => this.cancel())
      },
      edit () { this.$emit('input', true) },
      cancel () { this.$emit('input', false) }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/FeedbackActions.vue